import React, { FC, Dispatch, SetStateAction } from 'react';

import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Radio from '@mui/material/Radio';

interface RadioButtonsDesktopProps {
  radioOptions: any[];
  value: any;
  setValue: Dispatch<SetStateAction<any>>;
}

const RadioButtonsDesktop: FC<RadioButtonsDesktopProps> = (props) => {
  let { radioOptions, value, setValue } = props;

  return (
    <Grid container>
      {radioOptions?.map((radioOption) => {
        return (
          <Grid item xs={4} style={{ display: 'flex', alignItems: 'center' }} key={radioOption.label}>
            <Radio
              checked={value?.toString() === radioOption.value.toString()}
              onChange={() => setValue(radioOption.value)}
            />
            <Typography>{radioOption.label}</Typography>
          </Grid>
        );
      })}
    </Grid>
  );
};

export default RadioButtonsDesktop;
